import Vue from 'vue'
import { throttle } from 'lodash'
import search from './search'
import EventBus from '../_event-bus'
import { $, sleep } from '../_utils'

const THROTTLE_THRESHOLD = 16
const BREAKPOINT = 1080

Vue.component('vue-header', {
  template: '#vue-header-template',
  props: ['account-links', 'initialCartItems', 'links', 'timelineSteps', 'timelineType'],
  mixins: [search],
  data() {
    return {
      activeSubmenu: '',
      activeTab: '',
      cartItemsCount: this.$props.initialCartItems
        ? this.countCartItems(this.initialCartItems)
        : [],
      closeTimeout: null,
      currentScroll: null,
      headerHeight: null,
      isOpen: false,
      layout: '',
      scrolled: false,
      scrollState: null,
      searchResults: [],
    }
  },
  methods: {
    addCartUpdateListener,
    addResizeListener,
    addScrollListener,
    countCartItems,
    getScrollPosition,
    handleHamburgerMenu,
    handleSearchEvent,
    setActiveTab,
    setBackground,
    setHeaderHeight,
    setLayout,
    setSubmenuWidth,
    toggleActiveTab,
    toggleSubmenu,
  },
  async mounted() {
    this.addCartUpdateListener()
    this.setLayout(window.innerWidth)
    this.setBackground()
    await sleep(0)
    this.setHeaderHeight()
    this.addResizeListener()
    this.addScrollListener()
  },
  create() {
    this.handleSearchEvent()
  },
  computed: {
    isLoggedIn,
    isRegister,
    logoStyles,
    last,
    scrollOff,
  },
})

new Vue({
  el: '#vue-header-wrapper',
})

function addCartUpdateListener() {
  EventBus.$on('update-cart', items => {
    this.cartItemsCount = this.countCartItems(items)
  })
}

function addResizeListener() {
  EventBus.$on('resize', viewportWidth => {
    this.setHeaderHeight()
    this.setLayout(viewportWidth)
  })
}

function addScrollListener() {
  window.addEventListener('scroll', throttle(this.setBackground, THROTTLE_THRESHOLD))
}

function countCartItems(items) {
  return items.reduce((acc, { count }) => acc + count, 0)
}

function getScrollPosition() {
  return window.scrollY
}

function handleHamburgerMenu() {
  this.isOpen = !this.isOpen
  this.setActiveTab('')

  if (this.isOpen) {
    document.body.classList.add('oy-hidden')
  } else {
    document.body.classList.remove('oy-hidden')
  }
}

function isLoggedIn() {
  return document.body.classList.contains('is-logged-in')
}

function isRegister() {
  return document.body.classList.contains('is-register')
}

function last() {
  return this.links.length - 1
}

function logoStyles() {
  const logoUrl =
    this.layout === 'desktop' ? './src/images/logo-aflo.png' : './src/images/logo-aflo-mobile.png'
  const logoStyle = { backgroundImage: `url(${logoUrl})` }
  return logoStyle
}

function scrollOff() {
  const headerScrollHeihgt = $('#vue-header-wrapper').scrollHeight

  return headerScrollHeihgt
}

function setActiveTab(tab) {
  this.activeTab = tab

  if (tab === 'search') {
    setTimeout(() => {
      this.$refs.searchInput.focus()
    })
  }
}

function setBackground() {
  this.currentScroll = this.getScrollPosition()
  this.currentScroll > 1 ? (this.scrolled = true) : (this.scrolled = false)
  const headerParentComponent = $('#vue-header-wrapper')
  this.scrolled
    ? headerParentComponent.classList.add('scrolled')
    : headerParentComponent.classList.remove('scrolled')
}

function setHeaderHeight() {
  if (this.$refs.headerHead)
    document.body.style.setProperty('--header-height', `${this.$refs.headerHead.clientHeight}px`)
}

function setLayout(viewportWidth) {
  this.layout = viewportWidth <= BREAKPOINT ? 'mobile' : 'desktop'
}

function setSubmenuWidth(ref) {
  const $target = this.$refs[ref]
  const $headerContent = this.$refs.headerContent
  const headerRight = $headerContent.getBoundingClientRect().right
  const targetLeft = $target.getBoundingClientRect().left

  $target.style.setProperty('width', `${headerRight - targetLeft}px`)
}

function toggleActiveTab(tab) {
  const nextActiveTab = this.activeTab !== tab ? tab : ''

  this.setActiveTab(nextActiveTab)
}

function toggleSubmenu(ref) {
  this.setSubmenuWidth(ref)

  this.activeSubmenu = this.activeSubmenu === ref ? '' : ref
}
function handleSearchEvent() {
  EvnetBus.$on('header-search', data => {
    this.searchResults = data
  })
}
